import React from 'react';

import _ from 'lodash'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

import LoaderButton from './LoaderButton';

const styles = theme => ({
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexShrink: 0,
        marginRight: "10px"
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    textAlignRight: {
        textAlign: "right"
    },
    flex: {
        display: "flex"
    }
});

class ExpansionItem extends React.Component {

    state = {
        expanded: null,
        isLoading: false
    }

    constructor(props) {
        super(props)
        this.state = {
            ...props
        }
    }

    componentWillReceiveProps(props) {
        if(props === this.props) {
            return
        }
        this.setState({
            ...props
        })
    }

    render() {

        const { classes, title, subtitle, children, id, handleChange, header, type } = this.props;
        const { expanded, isLoading } = this.state;

        return(
            <ExpansionPanel expanded={expanded === id} onChange={handleChange(id)}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    {header}
                    {!header && (
                        <div className={classes.flex}>
                            <Typography className={classes.heading}>{title}</Typography>
                            <Typography className={classes.secondaryHeading}>{subtitle}</Typography>
                        </div>
                    )}
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    {children}
                </ExpansionPanelDetails>
                <Divider />
                <ExpansionPanelActions>
                    <Grid container direction="row" alignItems="center">
                        <Grid item xs={6}>
                            <Button size="small" onClick={() => this.props.deleteAction(id)} color="secondary" variant=""><DeleteForeverIcon /></Button>
                        </Grid>
                        <Grid item xs={6} className={classes.textAlignRight}>
                            <Button size="small" onClick={handleChange(id)} color="secondary">Abbrechen</Button>
                            <LoaderButton name="Speichern" color="primary" onClick={() => this.props.saveAction(id)} loading={isLoading} />
                        </Grid>
                    </Grid>

                </ExpansionPanelActions>
            </ExpansionPanel>
        )
    }

}

export default (withStyles(styles)(ExpansionItem));



// WEBPACK FOOTER //
// ./src/Components/ExpansionItem.js